/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Languages_RequiredInputs */

const en_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages Required`)
};

const de_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderliche Sprachen`)
};

const fr_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langues requises`)
};

const es_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas requeridos`)
};

const it_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingue richieste`)
};

const nl_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereiste talen`)
};

const pl_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymagane języki`)
};

const fi_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaaditut kielet`)
};

const da_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Påkrævede sprog`)
};

const sv_jobs_languages_required = /** @type {(inputs: Jobs_Languages_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Språkkrav`)
};

/**
* | output |
* | --- |
* | "Languages Required" |
*
* @param {Jobs_Languages_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_languages_required = /** @type {((inputs?: Jobs_Languages_RequiredInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Languages_RequiredInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_languages_required(inputs)
	if (locale === "fr") return fr_jobs_languages_required(inputs)
	if (locale === "es") return es_jobs_languages_required(inputs)
	if (locale === "it") return it_jobs_languages_required(inputs)
	if (locale === "nl") return nl_jobs_languages_required(inputs)
	if (locale === "pl") return pl_jobs_languages_required(inputs)
	if (locale === "fi") return fi_jobs_languages_required(inputs)
	if (locale === "da") return da_jobs_languages_required(inputs)
	if (locale === "sv") return sv_jobs_languages_required(inputs)
	return en_jobs_languages_required(inputs)
});